// src/components/common/MaintenanceBanner/MaintenanceBanner.tsx

import * as React from 'react';
import injectSheet from 'react-jss';

import {
  getMaintenanceConfig,
  getMaintenanceState,
  formatMaintenanceTime,
  isBannerDismissed,
  dismissBanner,
} from 'src/utils/maintenance';
import { MaintenanceBannerHtml } from './MaintenanceBanner.html';
import { styles } from './MaintenanceBanner.styles';

interface IProps {
  classes: Record<string, string>;
}

const MaintenanceBanner: React.FC<IProps> = ({ classes }) => {
  const config = getMaintenanceConfig();
  const state = getMaintenanceState();

  const [dismissed, setDismissed] = React.useState(() =>
    isBannerDismissed(config.startTime),
  );

  if ((state !== 'scheduled' && state !== 'incident' && state !== 'resolved') || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    dismissBanner(config.startTime);
    setDismissed(true);
  };

  const formattedTime = formatMaintenanceTime(config.startTime);

  return (
    <MaintenanceBannerHtml
      classes={classes}
      state={state}
      formattedTime={formattedTime}
      estimatedDuration={config.estimatedDuration}
      message={config.message}
      onDismiss={handleDismiss}
    />
  );
};

export default injectSheet(styles)(MaintenanceBanner);
